export const LANGUAGE = 'current_language';
export const COOKIE_CONSENT = 'cookie_consent'